import React from "react";
import { Box, CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { ShareActionProvider } from "../contexts/ShareActionContext";
import SpouseValueCalculator from "../components/tools/SpouseValueCalculator";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#0f0f0f",
      paper: "#1a1a1a",
    },
    primary: {
      main: "#3182CE",
    },
  },
});

const SharedWifeValueCalculatorToolPage: React.FC = () => {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <ShareActionProvider>
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            mx: 0,
            minHeight: "100vh",
            p: { xs: 1.5, sm: 2 },
            bgcolor: "background.default",
          }}
        >
          <SpouseValueCalculator />
        </Box>
      </ShareActionProvider>
    </ThemeProvider>
  );
};

export default SharedWifeValueCalculatorToolPage;
